import React from "react";
import { FeaturedImage, PublishDate, Link, Excerpt } from "newsItemHelpers";

import styles from "./NewsListItem.scss";

const NewsListItem = props => {
  const { newsItem, settings } = props;

  // Set localized text / date format
  let _readMore;
  switch (settings.lang.toLowerCase()) {
    case "fr":
      _readMore = "En lire plus";
      break;
    case "es":
      _readMore = "Leer más";
      break;
    default:
      _readMore = "Read more";
  }

  // Configure if and where to show post date
  let _showDate = false;
  if (settings.showDate.constructor === Boolean) {
    _showDate = settings.showDate.toString().toLowerCase();
  } else {
    _showDate = settings.showDate.toString().toLowerCase();
  }

  // Set featured image url and alt text
  let _featuredImageHTML = (
    <FeaturedImage
      data={newsItem}
      fallbackImage={settings.fallbackImage}
      size={{ width: 720, height: 405, fit: "fill" }}
      className={styles.image}
    />
  );

  let _articleHTML = (
    <div className={`news__header-news-container ${styles.newsContainer}`}>
      <header className={`news__header ${styles.header}`}>
        {_showDate === "true" && (
          <PublishDate
            date={newsItem.postDate}
            lang={settings.lang}
            className={styles.pubDate}
          />
        )}
        {/* If we are displaying show more, just output the subject title, if not, output the subject title as the link */}
        {settings.showReadMore ? (
          <p className={`news__header-title ${styles.headerTitle}`}>
            {newsItem.subjectTitle}
          </p>
        ) : (
          <Link
            useModal={settings.useModal}
            toggleNewsModal={props.toggleNewsModal}
            basePath={settings.basePath}
            newsItem={newsItem}
            className={"news__header-link"}
            content={newsItem.subjectTitle}
          />
        )}
      </header>
      {settings.showExcerpt && newsItem.excerpt && (
        <Excerpt content={newsItem.excerpt} />
      )}
      {_showDate === "bottom" && (
        <PublishDate
          date={newsItem.postDate}
          lang={settings.lang}
          className={styles.pubDate}
        />
      )}
      {settings.showReadMore && (
        <Link
          useModal={settings.useModal}
          toggleNewsModal={props.toggleNewsModal}
          basePath={settings.basePath}
          newsItem={newsItem}
          className={"news__link"}
          content={_readMore}
        />
      )}
    </div>
  );

  return (
    <article className={`news__article ${styles.article}`}>
      {_showDate === "top" && newsItem.postDate && (
        <PublishDate
          date={newsItem.postDate}
          lang={settings.lang}
          className={styles.pubDate}
        />
      )}
      {/* If displaying featured image in list view, wrap entire output in container */}
      {settings.showImage ? (
        <div className={`news__article-container ${styles.articleContainer}`}>
          {settings.useImageLink ? (
            <Link
              useModal={settings.useModal}
              toggleNewsModal={props.toggleNewsModal}
              basePath={settings.basePath}
              newsItem={newsItem}
              className={`news__header-image-container ${
                styles.imageContainer
              } news__header-image-link ${styles.imageContainerLink}`}
              content={_featuredImageHTML}
            />
          ) : (
            <div
              className={`news__header-image-container ${
                styles.imageContainer
              }`}
            >
              {_featuredImageHTML}
            </div>
          )}
          {_articleHTML}
        </div>
      ) : (
        // If not displaying featured image in list view, just output article
        _articleHTML
      )}
    </article>
  );
};

export default NewsListItem;
